(function (M) {
  if (!M) return;
  var d = document, hero = d.querySelector('.cn-hero');
  if (!hero) return;
  hero.classList.add('cn-curtain'); hero.setAttribute('data-mo-play', '');
  M.tag('.cn-hero .logo-top', 'fade', { d: 0.3 });
  M.tag('.cn-hero .g > div:first-child > *', 'up', { d: 0.35, step: 0.12 });
  var prod = d.querySelector('.cn-hero .prod');
  if (prod) { M.tag(prod, 'rise', { d: 0.5 }); prod.classList.add('mo-float'); }
  M.tag('.cn-hero .jp', 'fade', { d: 0.8 });
  var duo = d.querySelector('.cn-duo');
  if (!duo) return;
  duo.classList.add('cn-curtain'); duo.setAttribute('data-mo-play', '');
  M.tag('.cn-duo .set img', 'rise');
  var items = M.all('.cn-duo .item');
  M.tag(items, 'right', { d: 0.15, step: 0.3 });
  if (items[1]) {
    items[1].classList.add('cn-has-plus');
    M.add(items[1], '<span class="cn-plus mo-deco" aria-hidden="true">+</span>', 'afterbegin');
  }
  [['.cn-duo .item:nth-child(1) h4', '120'], ['.cn-duo .item:nth-child(2) h3', '2000'], ['.cn-duo .item:nth-child(2) h4', '300']].forEach(function (c) {
    var s = M.count(c[0], c[1]);
    if (s) s.style.setProperty('--cn-w', c[1].length + 'ch');
  });
  M.all('.cn-deal.promo-off').forEach(function (deal) { M.tag(M.all(':scope > *', deal), 'up', { d: 0.2, step: 0.1 }); });
})(window.FJKMotion);
